import type { ProcessChargeResult } from '../../services/billing';
import type { ToastType } from '../../providers/ToastProvider';

type ChargePushAction = 'process' | 'retry';

function invoices(count: number): string {
    return `${count} invoice${count !== 1 ? 's' : ''}`;
}

export function chargeResultToast(
    result: ProcessChargeResult,
    action: ChargePushAction
): { message: string; type: ToastType } {
    if (result.failCount > 0) {
        const failed = action === 'retry' ? 'still failed' : 'failed';
        return {
            message: `${result.failCount} of ${invoices(result.invoiceCount)} ${failed}, check the charge error`,
            type: 'error'
        };
    }
    return {
        message: `${invoices(result.invoiceCount)} created (${result.chargeRef})`,
        type: 'success'
    };
}
